import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import _ from "lodash";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import Crud from "../Crud";
import InputSelect from "../InputSelect";

const sports = [
  {
    value: "CBB  ",
    text: "COLLEGE BASKETBALL",
  },
  {
    value: "CFB  ",
    text: "COLLEGE FOOTBALL",
  },
  {
    value: "NBA  ",
    text: "NBA BASKETBALL",
  },
  {
    value: "NFL  ",
    text: "NFL FOOTBALL",
  },
  {
    value: "SOC  ",
    text: "SOCCER",
  },
];

const options = [
  {
    value: 0,
    text: "No steps",
  },
  {
    value: 1,
    text: "Steps by ¼",
  },
  {
    value: 2,
    text: "Steps by ½",
  },
];

const plays = [
  {
    value: 0,
    text: "Spread",
  },
  {
    value: 1,
    text: "Total",
  },
];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function Derivatives() {
  const [sport, setSport] = useState("CBB  ");
  const onSportChanged = useCallback((s) => setSport(s), []);

  // LEAGUES
  const [leaguesAdded, setLeaguesAdded] = useState([]);
  const [league, setLeague] = useState("");
  const onLeagueChanged = useCallback((l) => setLeague(l), []);

  const onGetListLeagues = useCallback(
    (data) => {
      if (data.length > 0 && !league && leaguesAdded.length === 0) {
        setLeague(data[0].value);
      }
      return _.uniqBy([...data, ...leaguesAdded], "value");
    },
    [league, leaguesAdded]
  );

  const { values: leagues } = useDataFormatterHook({
    value: "idLeague",
    text: "leagueDesc",
    path: `/Game/DerivativeConfigByLeague_ListLeagues?idSport=${sport}`,
    onGetList: onGetListLeagues,
  });

  const { values: periods, formatter: periodsFormatter } = useDataFormatterHook(
    {
      value: "numberOfPeriod",
      text: "periodDescription",
      path: `/Game/Period_GetList?idSport=${sport}`,
    }
  );

  const [openDerivativePrice, setOpenDerivativePrice] = React.useState(false);
  const onOpenDerivativePriceChange = useCallback((open) => {
    setOpenDerivativePrice(open);
  }, []);

  const [openDerivativePriceByLeague, setOpenDerivativePriceByLeague] =
    React.useState(false);
  const onOpenDerivativePriceByLeagueChange = useCallback((open) => {
    setOpenDerivativePriceByLeague(open);
  }, []);

  const [openLeagueSelection, setOpenLeagueSelection] = React.useState(false);
  const onOpenLeagueSelectionChange = useCallback((open) => {
    setOpenLeagueSelection(open);
  }, []);

  const [selectedDerivative, setSelectedDerivative] = React.useState(null);
  const onSeletedDerivativeChanged = useCallback(
    (derivative) => {
      setSelectedDerivative({
        ...derivative,
        SportDescription: sports.find((s) => s.value === derivative.idSport)
          ?.text,
        PeriodDescription: periods.find((p) => p.value === derivative.period)
          ?.text,
      });
      setOpenDerivativePrice(true);
    },
    [periods]
  );

  const [selectedDerivativeByLeague, setSelectedDerivativeByLeague] =
    React.useState(null);
  const onSeletedDerivativeByLeagueChanged = useCallback(
    (derivative) => {
      setSelectedDerivativeByLeague({
        ...derivative,
        LeagueDescription: leagues.find((l) => l.value === derivative.idLeague)
          ?.text,
        PeriodDescription: periods.find((p) => p.value === derivative.period)
          ?.text,
      });
      setOpenDerivativePriceByLeague(true);
    },
    [leagues, periods]
  );

  const optionsFormatter = useCallback((cell, row, text) => {
    const itemText = options.find((item) => item?.value === cell)?.text;
    if (text) return itemText;
    return <span>{itemText}</span>;
  }, []);

  const playFormatter = useCallback((cell, row, text) => {
    const itemText = plays.find((item) => item?.value === cell)?.text;
    if (text) return itemText;
    return <span>{itemText}</span>;
  }, []);

  // LEAGUES BY SPORT
  const [leagueBySport, setLeagueBySport] = useState("");
  const onLeaguesBySportChanged = useCallback((l) => {
    setLeagueBySport(l);
  }, []);

  const onGetListLeaguesBySport = useCallback(
    (data) => {
      if (data.length > 0 && !leagueBySport) {
        setLeagueBySport(data[0].value);
      }
      return data;
    },
    [leagueBySport]
  );

  const { values: leaguesBySport } = useDataFormatterHook({
    value: "idLeague",
    text: "description",
    path: `/League/League_GetLeaguesByIdSport?idSport=${sport}`,
    onGetList: onGetListLeaguesBySport,
  });

  const onLeaguesBySportAdd = useCallback(() => {
    if (leagueBySport) {
      const selectedLeague = leaguesBySport.find(
        (l) => l.value === leagueBySport
      );
      setLeague(leagueBySport);
      setLeagueBySport("");
      setLeaguesAdded([...leaguesAdded, selectedLeague]);
    }
    onOpenLeagueSelectionChange(false);
  }, [
    leagueBySport,
    leaguesAdded,
    onOpenLeagueSelectionChange,
    leaguesBySport,
  ]);

  // const [changesDerivative, setChangesDerivative] = useState(null);
  // const onChangesDerivativeChanged = useCallback((derivative) => {
  //   setChangesDerivative(derivative);
  // }, []);

  return (
    <div className="flex flex-col gap-2">
      {/* <ChangesInjected
        params={{
          ChangeType: 28,
          IdSport: "",
          Param1: changesDerivative?.IdDerivativeConfig,
          Param2: 0,
          Param3: 0,
        }}
      /> */}
      {/* DERIVATIVE PRICES */}
      <Dialog
        open={openDerivativePrice}
        onClose={onOpenDerivativePriceChange}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Edit Derivative Prices</DialogTitle>
        <DialogContent>
          <div className="flex flex-col">
            <span className="text-lg font-light">
              Sport: {selectedDerivative?.SportDescription}
            </span>
            <span className="text-lg font-light">
              Period: {selectedDerivative?.PeriodDescription}
            </span>
          </div>
          <Crud
            pagination={false}
            getUrl={() =>
              `/Game/DerivativePrice_List?idSport=${selectedDerivative.idSport?.trim()}&period=${selectedDerivative?.period
              }`
            }
            getPreProcess={(data) => _.sortBy(data, ["points"])}
            // INSERT
            insertUrl={() => "/Game/DerivativePrice_Insert"}
            insertParams={({ userId }, { play, points, pushRate }) => ({
              IdSport: selectedDerivative.idSport,
              Period: selectedDerivative.period,
              Play: play,
              Points: points,
              PushRate: pushRate,
              IdUser: Number(userId),
            })}
            // UPDATE
            updateUrl={() => "/Game/DerivativePrice_Update"}
            updateParams={({ userId }, { idDerivativePrice, pushRate }) => ({
              IdDerivativePrice: idDerivativePrice,
              PushRate: pushRate,
              IdUser: Number(userId),
            })}
            // DELETE
            deleteUrl={() => "/Game/DerivativePrice_Delete"}
            deleteParams={({ userId }, _, { idDerivativePrice }) => ({
              IdDerivativePrice: idDerivativePrice,
              IdUser: Number(userId),
            })}
          >
            <TableHeaderColumn
              visible="none"
              hiddenOnInsert
              autoValue={true}
              hidden
              isKey
              dataField="idDerivativePrice"
            >
              Id
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="play"
              dataFormat={playFormatter}
              editable={false}
            >
              Play
            </TableHeaderColumn>
            <TableHeaderColumn dataField="points" editable={false}>
              Points
            </TableHeaderColumn>
            <TableHeaderColumn dataField="pushRate">
              Push Rate
            </TableHeaderColumn>
          </Crud>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => onOpenDerivativePriceChange(false)}
            color="secondary"
            variant="contained"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* DERIVATIVE BY LEAGUE PRICES */}
      <Dialog
        open={openDerivativePriceByLeague}
        onClose={onOpenDerivativePriceByLeagueChange}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Edit Derivative by League Prices</DialogTitle>
        <DialogContent>
          <div className="flex flex-col">
            <span className="text-lg font-light">
              League: {selectedDerivativeByLeague?.LeagueDescription}
            </span>
            <span className="text-lg font-light">
              Period: {selectedDerivativeByLeague?.PeriodDescription}
            </span>
          </div>
          <Crud
            pagination={false}
            getUrl={() =>
              `/Game/DerivativePriceByLeague_List?idLeague=${selectedDerivativeByLeague.idLeague}&period=${selectedDerivativeByLeague?.period}`
            }
            getPreProcess={(data) => _.sortBy(data, ["points"])}
            // INSERT
            insertUrl={() => "/Game/DerivativePriceByLeague_Insert"}
            insertParams={({ userId }, { play, points, pushRate }) => ({
              IdLeague: selectedDerivativeByLeague.idLeague,
              IdSport: selectedDerivativeByLeague.idSport,
              Period: selectedDerivativeByLeague.period,
              Play: play,
              Points: points,
              PushRate: pushRate,
              IdUser: Number(userId),
            })}
            // UPDATE
            updateUrl={() => "/Game/DerivativePriceByLeague_Update"}
            updateParams={(
              { userId },
              { idDerivativePriceByLeague, pushRate }
            ) => ({
              IdDerivativePriceByLeague: idDerivativePriceByLeague,
              PushRate: pushRate,
              IdUser: Number(userId),
            })}
            // DELETE
            deleteUrl={() => "/Game/DerivativePriceByLeague_Delete"}
            deleteParams={({ userId }, _, { idDerivativePriceByLeague }) => ({
              IdDerivativePriceByLeague: idDerivativePriceByLeague,
              IdUser: Number(userId),
            })}
          >
            <TableHeaderColumn
              visible="none"
              hiddenOnInsert
              autoValue={true}
              hidden
              isKey
              dataField="idDerivativePriceByLeague"
            >
              Id
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="play"
              dataFormat={playFormatter}
              editable={false}
            >
              Play
            </TableHeaderColumn>
            <TableHeaderColumn dataField="points" editable={false}>
              Points
            </TableHeaderColumn>
            <TableHeaderColumn dataField="pushRate">
              Push Rate
            </TableHeaderColumn>
          </Crud>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => onOpenDerivativePriceByLeagueChange(false)}
            color="secondary"
            variant="contained"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openLeagueSelection}
        onClose={onOpenLeagueSelectionChange}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>League Selection</DialogTitle>
        <DialogContent>
          <InputSelect
            variant="outlined"
            size="small"
            label="Sport"
            name="name"
            data={leaguesBySport.filter(
              (l) => !leagues.find((ll) => ll.value === l.value)
            )}
            placeholder="DataFormatter"
            setSelectValue={onLeaguesBySportChanged}
            startValue={leagueBySport ?? leaguesBySport?.[0]?.value}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => onOpenLeagueSelectionChange(false)}
            color="secondary"
            variant="contained"
            autoFocus
          >
            Close
          </Button>
          <Button
            onClick={onLeaguesBySportAdd}
            color="primary"
            variant="contained"
            autoFocus
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>

      <h2>Derivative Config</h2>
      <InputSelect
        variant="outlined"
        size="small"
        label="Sport"
        name="name"
        data={sports}
        placeholder="DataFormatter"
        setSelectValue={onSportChanged}
        startValue={sport}
      />
      <Crud
        pagination={false}
        getUrl={() => `/Game/DerivativeConfig_List?idSport=${sport}`}
        // INSERT
        insertUrl={() => "/Game/DerivativeConfig_Insert"}
        insertParams={(
          { userId },
          {
            idSport,
            period,
            derivOptions,
            spread_MaxLines,
            total_MaxLines,
            spread_PushRate,
            total_PushRate,
          }
        ) => ({
          IdSport: idSport,
          Period: period,
          DerivOptions: derivOptions,
          Spread_MaxLines: spread_MaxLines,
          Total_MaxLines: total_MaxLines,
          Spread_PushRate: spread_PushRate,
          Total_PushRate: total_PushRate,
          IdUser: Number(userId),
        })}
        // UPDATE
        updateUrl={() => "/Game/DerivativeConfig_Update"}
        updateParams={(
          { userId },
          {
            idDerivativeConfig,
            derivOptions,
            spread_MaxLines,
            total_MaxLines,
            spread_PushRate,
            total_PushRate,
          }
        ) => ({
          IdDerivativeConfig: idDerivativeConfig,
          DerivOptions: derivOptions,
          Spread_MaxLines: spread_MaxLines,
          Total_MaxLines: total_MaxLines,
          Spread_PushRate: spread_PushRate,
          Total_PushRate: total_PushRate,
          IdUser: Number(userId),
        })}
      >
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          isKey
          dataField="idDerivativeConfig"
        >
          Id
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="period"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataFormat={periodsFormatter}
          editable={{ type: "select", options: { values: periods } }}
        >
          Period
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="derivOptions"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataFormat={optionsFormatter}
          editable={{ type: "select", options: { values: options } }}
        >
          Options
        </TableHeaderColumn>
        <TableHeaderColumn dataField="spread_MaxLines">
          Sprd Max Lines
        </TableHeaderColumn>
        <TableHeaderColumn dataField="total_MaxLines">
          Total Max Lines
        </TableHeaderColumn>
        <TableHeaderColumn dataField="spread_PushRate">
          Sprd Push Rate
        </TableHeaderColumn>
        <TableHeaderColumn dataField="total_PushRate">
          Total Push Rate
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="__"
          hiddenOnInsert
          autoValue={true}
          dataFormat={(_, derivative = {}) => (
            <div
              className="flex items-center justify-center gap-1 cursor-pointer"
              onClick={() => onSeletedDerivativeChanged(derivative)}
            >
              <i className="fa-solid fa-list"></i>
              <span>Prices</span>
            </div>
          )}
        ></TableHeaderColumn>
        {/* <TableHeaderColumn
          dataField="_"
          hiddenOnInsert
          autoValue={true}
          dataFormat={(_, derivative = {}) => (
            <div
              className="flex items-center justify-center gap-1 cursor-pointer"
              onClick={() => onChangesDerivativeChanged(derivative)}
            >
              <i className="fa-solid fa-clock-rotate-left"></i>
              <span>Last Changes</span>
            </div>
          )}
        ></TableHeaderColumn> */}
      </Crud>

      <hr className="my-4 border-gray-200" />
      <h2>League Exception Details</h2>
      <div className="flex items-center justify-center gap-2">
        <InputSelect
          variant="outlined"
          size="small"
          label="Leagues Exceptions"
          name="name"
          data={leagues}
          placeholder="DataFormatter"
          setSelectValue={onLeagueChanged}
          startValue={league}
        />

        <Button
          type="button"
          color="primary"
          variant="contained"
          onClick={() => onOpenLeagueSelectionChange(true)}
        >
          Add
        </Button>
      </div>
      {league && (
        <Crud
          pagination={false}
          getUrl={() =>
            `/Game/DerivativeConfigByLeague_List?idSport=${sport}&idLeague=${league}`
          }
          // INSERT
          insertUrl={() => "/Game/DerivativeConfigByLeague_Insert"}
          insertParams={(
            { userId },
            {
              period,
              derivOptions,
              spread_MaxLines,
              total_MaxLines,
              spread_PushRate,
              total_PushRate,
            }
          ) => ({
            IdLeague: league,
            IdSport: sport,
            Period: period,
            DerivOptions: derivOptions,
            Spread_MaxLines: spread_MaxLines,
            Total_MaxLines: total_MaxLines,
            Spread_PushRate: spread_PushRate,
            Total_PushRate: total_PushRate,
            IdUser: Number(userId),
          })}
          // UPDATE
          updateUrl={() => "/Game/DerivativeConfigByLeague_Update"}
          updateParams={(
            { userId },
            {
              idDerivativeConfigByLeague,
              derivOptions,
              spread_MaxLines,
              total_MaxLines,
              spread_PushRate,
              total_PushRate,
            }
          ) => ({
            IdDerivativeConfigByLeague: idDerivativeConfigByLeague,
            DerivOptions: derivOptions,
            Spread_MaxLines: spread_MaxLines,
            Total_MaxLines: total_MaxLines,
            Spread_PushRate: spread_PushRate,
            Total_PushRate: total_PushRate,
            IdUser: Number(userId),
          })}
          // DELETE
          deleteUrl={() => "/Game/DerivativeConfigByLeague_Delete"}
          deleteParams={(_, __, { idDerivativeConfigByLeague }) => ({
            IdDerivativeConfigByLeague: idDerivativeConfigByLeague,
          })}
        >
          <TableHeaderColumn
            visible="none"
            hiddenOnInsert
            autoValue={true}
            hidden
            isKey
            dataField="idDerivativeConfigByLeague"
          >
            Id
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="period"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataFormat={periodsFormatter}
            editable={{ type: "select", options: { values: periods } }}
          >
            Period
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="derivOptions"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataFormat={optionsFormatter}
            editable={{ type: "select", options: { values: options } }}
          >
            Options
          </TableHeaderColumn>
          <TableHeaderColumn dataField="spread_MaxLines">
            Sprd Max Lines
          </TableHeaderColumn>
          <TableHeaderColumn dataField="total_MaxLines">
            Total Max Lines
          </TableHeaderColumn>
          <TableHeaderColumn dataField="spread_PushRate">
            Sprd Push Rate
          </TableHeaderColumn>
          <TableHeaderColumn dataField="total_PushRate">
            Total Push Rate
          </TableHeaderColumn>
          <TableHeaderColumn
            hiddenOnInsert
            autoValue={true}
            dataFormat={(_, derivativeByLeague = {}) => (
              <div
                className="flex items-center justify-center gap-1 cursor-pointer"
                onClick={() =>
                  onSeletedDerivativeByLeagueChanged(derivativeByLeague)
                }
              >
                <i className="fa-solid fa-list"></i>
                <span>Prices</span>
              </div>
            )}
          ></TableHeaderColumn>
        </Crud>
      )}
    </div>
  );
}

export default Derivatives;
